import React from "react";

const Customaibanner = () => {
  const bannerStyles = {
    // marginTop:"60px",
    width: "100%",
    height: "90vh", 
    backgroundImage: "url('/image/custom-ai-solutions-hero.jpg')",  
    backgroundSize: "cover",
    backgroundPosition: "center center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    color: "white",
    position: "relative",
    overflow: "hidden",
  };

  const contentStyles = {
    maxWidth: "90%",
    padding: "0 20px",  
  };

  const headingStyles = {
    fontSize: "4rem",  
    margin: 0,
    lineHeight: 1.2,
    fontWeight: "bold",
  };

  const paragraphStyles = {
    fontSize: "1.5rem",  
    marginTop: "1rem",
  };

  
  const mediaQueryStyles = {
    "@media (max-width: 1200px)": {
      heading: { fontSize: "3.5rem" },
      paragraph: { fontSize: "1.3rem" },
    },
    "@media (max-width: 768px)": {
      heading: { fontSize: "2.5rem" },
      paragraph: { fontSize: "1.2rem" },
    },
    "@media (max-width: 480px)": {
      heading: { fontSize: "2rem" },
      paragraph: { fontSize: "1rem" },
    },
  };

  return (
    <div style={bannerStyles}>
      <div style={contentStyles}>
       
        
      </div>
    </div>
  );
};

export default Customaibanner;






